import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c570d0ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-api-associated" }
const _hoisted_2 = { class: "create-api-header" }
const _hoisted_3 = { class: "create-api-flow" }
const _hoisted_4 = { class: "scroll-content" }
const _hoisted_5 = {
  key: 0,
  class: "add-product-absolute"
}

import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import HeaderTip from './components/HeaderTip.vue'
import FlowPath from './components/FlowPath.vue'
import ApiGoods from './components/ApiGoods/ApiGoods.vue'
import PlatformGoods from './components/PlatformGoods/PlatformGoods.vue'
import BindErrorModal from './components/BindErrorModal.vue'
import useData, { getNewProductList, diffProductList, getProductDetail } from './useData'
import { shopGoodsBindApi } from '@/apis/goods'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import AddProductTip from './components/AddProductTip.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const bindErrorModalRef = ref()
const store = useStore()
const route = useRoute()
const shopDetail: any = ref({})
const productList: any = ref([])
const loading = ref(false)
const height = ref(0)
const isShowTip = ref(false)
const product = ref({})
const showProductModal = ref(false)

const keyIndex = ref(0)
let isFirst = true
// 是否授权
const isAuth = computed(() => {
  console.log('store.getters?.shopInfo', store.getters?.shopInfo)
  return store.getters?.shopInfo?.authStatus === '1' || store.getters?.shopInfo?.customerShopPlatform === 7
})

console.log(isAuth, 'isAuth')

const shopItemId = ref(String(route.query.shopItemId ?? ''))
const init = async (shopId?: string) => {
  if (shopId) {
    shopItemId.value = shopId
  }
  if (!isAuth.value || !shopItemId.value) return
  loading.value = true
  const { shopDetail: detail, productList: list } = await useData(shopItemId.value)
  shopDetail.value = detail
  productList.value = list
  keyIndex.value++
  loading.value = false
  if (route.query.productSku && isFirst) {
    isFirst = false
    store.dispatch('goods/setSku', route.query.productSku)
  }
}
init()

// 绑定sku
// isUnbind 是否解绑 isDelete 是否删除 setMain 设为主商品
const bindProduct = async (params: { productIndex: number, shopSkuIndex: number, productSku: string, isUnbind?: boolean, isDelete?: boolean, setMain?: boolean }) => {
  console.log('绑定sku params', params)
  const { productIndex, shopSkuIndex, productSku, isUnbind, isDelete } = params
  loading.value = true
  let newList = []
  if (isDelete) {
    // 删除商品
    newList = productList.value.filter((i, k) => k !== productIndex)
  } else if (params.setMain) {
    newList = [productList.value[productIndex], ...productList.value.filter((i, k) => k !== productIndex)]
  } else {
    if (!isUnbind && productSku) {
      // 修改sku校验同一行是否有重复的sku拦截
      const isWarn = productList.value.find((item: any) => item?.shopSkuList?.[shopSkuIndex]?.activeProduct?.productSku === productSku)
      if (isWarn) {
        ElMessage.warning(t('当前sku已绑定'))
        loading.value = false
        return
      }
    }
    newList = getNewProductList({
      oldProductList: productList.value,
      productIndex: productIndex,
      shopSkuIndex: shopSkuIndex,
      productSku: productSku,
      isUnbind: isUnbind
    })
  }
  console.log('productList.value, newList', productList.value, newList)
  const reqData = diffProductList(productList.value, newList)
  reqData.skuMappingList.forEach((i: any) => {
    i.mappingInfoList.forEach((v: any) => {
      if (!v.productSku) return
      v.operateFlag = v.productSku === params.productSku
    })
  })
  console.log('reqData', reqData)
  // return
  if (reqData.skuMappingList.length > 0) {
    const { data: resultData } = await shopGoodsBindApi({
      ...reqData,
      unbindFlag: isUnbind || isDelete || false
    })
    console.log('iiii', resultData)
    loading.value = false
    if (resultData.bindedShopSkuInfoList?.length > 0) {
      bindErrorModalRef.value.open(resultData)
      return
    } else if (!isUnbind && !isDelete) {
      ElMessage.success(t('绑定成功'))
    }
  } else {
    // 如果没有sku更新直接更新视图
    loading.value = false
  }
  productList.value = newList
  const { shopDetail: detail } = await useData(shopItemId.value)
  shopDetail.value = detail
}
// 插入新店铺商品
const changeShopItem = (shopId: string) => {
  init(shopId)
}
// 添加平台商品
const addPlatformGoods = async (row: any, isCodeAdd?: boolean) => {
  if (!shopDetail.value.thirdItemCode) {
    ElMessage.warning(t('请先选择三方商品后，再添加此商品来绑定吧！'))
    return false
  }
  console.log('222', productList.value, row)
  if (productList.value.length === 30) {
    ElMessage.warning(t('最多只能绑定30个商品'))
    return false
  }
  try {
    const detailInfo = await getProductDetail(row)
    if (!detailInfo.productCode) return false
    detailInfo.shopSkuList = shopDetail.value.skuList.map((v: any) => {
      return {
        ...v,
        activeProduct: {}
      }
    })
    productList.value.push(detailInfo)
    keyIndex.value++
    if (isCodeAdd) {
      // 浮窗加入商品关闭浮窗
      showProductModal.value = false
    }
    return true
  } catch {
    return false
  }
}
// 删除店铺商品
const deleteShopItem = () => {
  shopDetail.value = {}
  productList.value = []
}

const [getValue] = useUserConfig(ENUM_CONFIG_CODE.API_ASSOCIATED_FLOW)
const getSkuHeight = () => {
  const ele: any = document.querySelector('.usecenter-pannel')
  height.value = (ele?.clientHeight ?? 0) - 122 - (isShowTip.value ? 76 : 0)
  console.log('height.value', height.value, isShowTip.value)
}
onMounted(async () => {
  isShowTip.value = await getValue() !== '1'
  getSkuHeight()
  window.addEventListener('resize', getSkuHeight)
  // 如果有productcode则查询商品展示弹窗
  if (!route.query.productCode) return
  const detailInfo = await getProductDetail({
    productType: Number(route.query.productType),
    productCode: String(route.query.productCode),
    productSku: String(route.query.productSku)
  })
  if (detailInfo.productCode) {
    product.value = detailInfo
    showProductModal.value = true
  }
})
onUnmounted(() => {
  window.removeEventListener('resize', getSkuHeight)
})

const closeModal = () => {
  showProductModal.value = false
}

return (_ctx: any,_cache: any) => {
  const _directive_drag = _resolveDirective("drag")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderTip)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FlowPath)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["api-goods", { 'width-100': !_unref(isAuth) || !shopDetail.value.thirdItemCode }])
      }, [
        _createVNode(ApiGoods, {
          shopDetail: shopDetail.value,
          isAuth: _unref(isAuth),
          onChange: changeShopItem,
          productList: productList.value,
          add: addPlatformGoods,
          onDelete: deleteShopItem,
          height: height.value - 326,
          loading: loading.value
        }, null, 8, ["shopDetail", "isAuth", "productList", "height", "loading"])
      ], 2),
      _withDirectives(_createVNode(PlatformGoods, {
        productList: productList.value,
        change: bindProduct,
        add: addPlatformGoods,
        height: height.value,
        keyIndex: keyIndex.value
      }, null, 8, ["productList", "height", "keyIndex"]), [
        [_vShow, _unref(isAuth) && shopDetail.value.thirdItemCode]
      ]),
      (showProductModal.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(AddProductTip, {
              product: product.value,
              onClose: closeModal,
              add: addPlatformGoods
            }, null, 8, ["product"])
          ], 512)), [
            [_directive_drag]
          ])
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(BindErrorModal, {
      ref: (_value, _refs) => {
        _refs['bindErrorModalRef'] = _value
        bindErrorModalRef.value = _value
      },
      productList: productList.value
    }, null, 8, ["productList"])
  ]))
}
}

})